import styled from 'styled-components';

export const StyledIconButtonContainer = styled.div<{ selected?: boolean }>`
	${(props) => (props.selected ? 'background-color: #f1faff !important;' : '')}
`;
